import { Injectable } from '@angular/core';
import { StoreConfig, Store } from '@datorama/akita';
import { LeaderboardV2Entry } from './models/leaderboard-v2.model';
import { MonthlyLeaderboardEntry } from './models/monthly-leaderboard-v2.model';

export interface LeaderboardV2State {
  leaderboardV2: LeaderboardV2Entry[];
  monthlyLeaderboardV2: MonthlyLeaderboardEntry;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'leaderboardV2' })
export class LeaderboardV2Store extends Store<LeaderboardV2State> {
  // todo: when multiple leaderboards V2 are implemented, make this an entity store that stores objects in this shape:
  // { date: Date, leaderboardV2: LeaderboardV2Entry[] }
  // keyed on date.
  constructor() {
    super({});
  }
}
